import { atom } from "jotai";

export const templatesAtom = atom([{ name: "", pageSize: "", layout: [] }]);

export const selectedTemplateAtom = atom({
  name: "",
  pageSize: "",
  layout: [],
});

export const hoverDroppableAtom = atom("");

export const editAtom = atom(false);

export const layoutContainerAtom = atom({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flexBasis: "64%",
});

export const pageContainerAtom = atom({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  width: "210mm",
  height: "297mm",
});

// export const priscriptionSequenceAtom = atom([
//   {
//     id: 1,
//     label: "Addictions",
//     offset: `ADDICTIONS`,
//     key: "customField",
//   },
//   {
//     id: 2,
//     label: "Allergy",
//     offset: "ALLERGY",
//     key: "customField",
//   },
//   {
//     id: 3,
//     label: "Patient History",
//     offset: "PATIENT_HISTORY",
//     key: "customField",
//   },
//   { id: 4, label: "Vitals", key: "vitals" },
//   { id: 5, label: "Medicine Details", key: "medicineTable" },
//   {
//     id: 6,
//     label: "Advice & Direction",
//     key: "adviceDirection",
//   },
//   { id: 7, label: "Next Visit", key: "nextVisit" },
// ]);

export const userRoleAtom = atom({});
